import { Divider } from '@mui/material';
import styled from 'styled-components';

export const FormRow = styled.div`
  margin-bottom: 16px;

  :last-child {
    margin-bottom: 0;
  }
`;

export const FormRowsDivider = styled(Divider)`
  margin-bottom: 16px;
  width: 100%;
`;

export const FormSectionTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
`;
